// import styled from 'styled-components'
// import { colors } from '../../theme'

// export const Container = styled.label`
//   display: block;
//   position: relative;
//   cursor: pointer;
//   -webkit-user-select: none;
//   -moz-user-select: none;
//   -ms-user-select: none;
//   user-select: none;
//   width: 26px;
//   input:checked ~ .checkmark {
//     background-color: ${colors.grey100};
//     border: 1px solid ${colors.grey300};
//   }
//   input:checked ~ .checkmark:after {
//     display: block;
//   }
//   .checkmark:after {
//     left: 3.6px;
//     bottom: 2.5px;
//     width: 3px;
//     height: 7px;
//     border: solid ${colors.grey700};
//     border-radius: 0px 0px;
//     border-width: 0px 2px 2px 0px;
//     -webkit-transform: rotate(45deg);
//     -ms-transform: rotate(45deg);
//     transform: rotate(45deg);
//   }
// `

// export const CheckboxStyled = styled.input`
//   position: absolute;
//   opacity: 0;
//   cursor: pointer;
//   height: 0;
//   width: 0;
// `

// export const Checkmark = styled.span<{
//   top: string
// }>`
//   position: absolute;
//   top: ${({ top }) => top};
//   left: 0;
//   height: 14px;
//   width: 14px;
//   background-color: ${colors.surface};
//   border: 2px solid ${colors.grey400};
//   border-radius: 1px;
//   &:after {
//     content: '';
//     position: absolute;
//     display: none;
//   }
// `

import styled from 'styled-components'
import { colors } from '../../theme'

export const Container = styled.label<{
  background?: boolean
  check?: string
}>`
  display: block;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 26px;
  input:checked ~ .checkmark {
    background-color: ${({ background }) =>
      background ? `${colors.grey100}` : `${colors.system}`};

    border: solid 1px
      ${({ check }) =>
        check === 'check' ? `${colors.grey400}` : `${colors.system}`};
  }
  input:checked ~ .checkmark:after {
    display: block;
  }
  .checkmark:after {
    left: 3.6px;
    bottom: 2.5px;
    width: 3px;
    height: 7px;
    border: solid
      ${({ check }) =>
        check === 'check' ? `${colors.grey700}` : `${colors.white}`};

    border-radius: 0px 0px;
    border-width: 0px 2px 2px 0px;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`

export const CheckboxStyled = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`

export const Checkmark = styled.span<{
  top: string
  bloqueado?: string
}>`
  position: absolute;
  top: ${({ top }) => top};
  left: 0;
  height: 14px;
  width: 14px;
  background-color: ${({ bloqueado }) =>
    bloqueado === 'bloqueado' ? `${colors.grey400}` : `${colors.surfaceHigh}`};
  border: solid 2px ${colors.grey400};
  border-radius: 1px;
  &:after {
    content: '';
    position: absolute;
    display: none;
  }
`
